import { Container } from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EventExampleTabContent } from '@/components/OrganiseEvent/EventExampleTabContent';
import { TAB_ITEMS } from '@/components/OrganiseEvent/eventExampleTabHelper';
import { EventExampleTabs } from '@/components/OrganiseEvent/EventExampleTabs';
import { RedCardWithDownloadButton } from '@/components/ui/shared/cards/RedCardWithDownloadButton/RedCardWithDownloadButton';

export const EventExamples = () => {
  const [activeTabIndex, setActiveTabIndex] = useState(null);
  const { t } = useTranslation();

  return (
    <Container my={16}>
      <EventExampleTabs tabItems={TAB_ITEMS} activeTabIndex={activeTabIndex} onChangeTab={setActiveTabIndex} />
      <EventExampleTabContent activeTab={TAB_ITEMS[activeTabIndex]?.labelKey} />

      <RedCardWithDownloadButton
        slug="hybrid-events-guide"
        mt={8}
        mx="auto"
        maxW="990px"
        smallHeading={t('hybridEventsPage.redCardSubheading')}
        heading={t('hybridEventsPage.redCardHeading')}
      />
    </Container>
  );
};
